<template>
  <div class="exit-warehouse-register-details">
    <el-form class="enter-warehouse-register-form" ref="exitWarehouseRegisterForm" :model="exitWarehouseRegisterForm">
      <div class="row">
        <div class="sub-title base-info-title">基本信息</div>
        <EnterExitWarehouseRegisterBaseInfo :type="'exit'" :id="orderId" :baseInfoList="baseInfoList"
          :baseInfoObj="baseInfoObj" @onSaveRemarks="onSaveRemarks"></EnterExitWarehouseRegisterBaseInfo>
      </div>

      <div class="row">
        <div class="sub-title entry-title" :class="isOpenEntry ? '' : 'close-entry-title'">
          条目基本信息
          <span v-if="isOpenEntry" class="open-close" @click="isOpenEntry = false">
            收起
            <i class="el-icon-caret-top"></i>
          </span>
          <span v-else class="open-close" @click="isOpenEntry = true">
            展开
            <i class="el-icon-caret-bottom"></i>
          </span>
        </div>
        <EnterExitWarehouseRegisterEntry :isOpenEntry="isOpenEntry" :tableData="tableData">
        </EnterExitWarehouseRegisterEntry>
      </div>

      <div class="row">
        <div class="row-title">
          <div class="sub-title">费用信息</div>
          <el-button class="btn-white" @click="downExcel"
            >导出明细</el-button
          >
        </div>
        <EnterExitWarehouseRegisterOperator 
          :form="'exit'"
          :receivableEmptyHeadUpSign="receivableEmptyHeadUpSign"
          :payEmptyHeadUpSign="payEmptyHeadUpSign"
          :registeredFeetableData="registeredFeetableData"
          :tabsList="tabsList"
          :defaultAccountsReceivableHeaderList="defaultAccountsReceivableHeaderList"
          :copingWithHeaderList="copingWithHeaderList"
          @onAddDomain="onAddDomain"
          @onChangeName="onChangeName"
          @onTotalAmount="onTotalAmount"
          ></EnterExitWarehouseRegisterOperator>
      </div>
      <div class="footer">
        <el-button class="btn-white" @click="closeDialog">
          取消
        </el-button>
        <el-button class="btn-blue" @click="saveRegister('exitWarehouseRegisterForm', 'receivable')">保存应收</el-button>
        <el-button class="btn-blue" @click="saveRegister('exitWarehouseRegisterForm', 'payable')">保存应付</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { keepTwoDecimal, modifyNetTitle } from "common/js/util";
import LookUpMixins from "common/mixins/look-up.js";
import currencyMixins from "common/mixins/currency.js";
import ExitWarehouseRegister from "models/exit-warehouse-register";
import EnterExitWarehouseRegisterOperator from "components/base/enter-exit-warehouse-register/enter-exit-warehouse-register-operator.vue"
import EnterExitWarehouseRegisterBaseInfo from "components/base/enter-exit-warehouse-register/enter-exit-warehouse-register-base-info.vue"
import EnterExitWarehouseRegisterEntry from "components/base/enter-exit-warehouse-register/enter-exit-warehouse-register-entry.vue"
export default {
  mixins: [currencyMixins, LookUpMixins],
  components: {
    EnterExitWarehouseRegisterBaseInfo,
    EnterExitWarehouseRegisterEntry,
    EnterExitWarehouseRegisterOperator
  },

  data() {
    return {
      // 订单id
      orderId: null,
      baseInfoList: [
        {name: '项目名称', key: 'projectName'},
        {name: '出仓单号', key: 'outboundOrderNo'},
        {name: '出仓日期', key: 'outboundDate'},
        {name: '总件数（件）', key: 'totalQuantity'},
        { name: '总毛重（吨）', key: 'totalGrossWeight'},
        { name: '总净重（吨）', key: 'totalNetWeight'},
        { name: '总体积（立方米）', key: 'totalVolume' },
        { name: '应收总价', key: 'totalPayablePrice' },
        { name: '应付总价', key: 'totalReceivablePrice' },
        {name: '提单号', key: 'ladingBillCode'},
        {name: '出仓报关单号', key: 'customsDeclarationNo'},
        {name: '20尺箱量', key: 'boxQuantity20'},
        {name: '40尺箱量', key: 'boxQuantity40'},
        {name: '进港码头', key: 'terminalPort'},
        {name: '提箱地', key: 'extractBoxPort'},
        {name: '目的港', key: 'destinationPort' },
        {name: '送货工厂', key: 'deliveryFactory' },
        { name: '出仓编号', key: 'outboundOrderNumber' },
        {name: '备注', key: 'remark'}
      ],
      baseInfoObj: {
        projectName: '',
        outboundOrderNo: '',
        outboundDate: '',
        totalQuantity: '',
        totalGrossWeight: '',
        totalNetWeight: '',
        totalVolume: '',
        totalPayablePrice: '',
        totalReceivablePrice: '',
        ladingBillCode: '',
        customsDeclarationNo: '',
        boxQuantity20: '',
        boxQuantity40: '',
        terminalPort: '',
        extractBoxPort: '',
        destinationPort: '',
        outboundOrderNumber: '',
        remark: ''
      },
      // 项目的默认应收抬头id
      receivableBillHeadId: '',
      exitWarehouseRegisterForm: {},

      // 已登记费用信息列表
      registeredFeetableData: [],
      // 进仓操作
      tabsList: [
        {
          key: 'receivable',
          name: '出仓操作应收费用',
          tableData: [],
          addServicetableData: []
        },
        { key: 'payable', name: '出仓操作应付费用', tableData: [], addServicetableData: [] }
      ],

      isOpenEntry: false,
      // 应收空抬头
      receivableEmptyHeadUpSign: false,
      // 应付空抬头
      payEmptyHeadUpSign: false,

      isOpenEntry: false,
      tableData: [],
      
      // 导出表格名称
      downExcelName: '',
      downExcelList: []
    }
  },

  created() {
    modifyNetTitle('出仓登记')
    this.orderId = Number(this.$route.query.exitWarehouseRegisterId)
    this.initDetails()
    this.initCopingWithHeaderList(true)
    this.initDefaultAccountsReceivableHeaderList(true)
  },

  methods: {
    /** 
     * @description 获取出仓详情
    */
    initDetails() {
      ExitWarehouseRegister.getExitWarehouseRegisterDetails(this.orderId).then(res => {
        if (res.success) {
          let { orderInfo, orderDetailList, orderFeeList, addServiceFeeList, feeCurrencyList } = res.result

          let arr = []
          orderDetailList.map((i, index) => {
            let obj = {}
            obj.sort = index + 1 < 10 ? `0${index + 1}` : index + 1
            obj.goodsName = i.goodsName
            obj.goodsQuantity = i.goodsQuantity
            obj.grossWeight = i.grossWeight
            obj.netWeight = i.netWeight
            obj.volume = i.volume
            arr.push(obj)
          })
          this.tableData = arr

          let feeCurrencyListArr = []
          feeCurrencyList.map((i, index) => {
            let obj = {}
            obj.sort = index + 1
            obj.currencySystem = i.currency
            obj.totalPayableAmount = i.payablePrice
            obj.totalAmountReceivable = i.receivablePrice
            obj.profit = keepTwoDecimal(i.receivablePrice - i.payablePrice)
            feeCurrencyListArr.push(obj)
          })
          this.registeredFeetableData = feeCurrencyListArr

          this.initBaseInfo(orderInfo)
          this.initExitWarehouseOperateList(orderFeeList, addServiceFeeList)
          
          this.handDownExcelData(addServiceFeeList, orderFeeList)
        } else {
          this.$message.error(res.message);
        }
      })
    },

    /** 
     * @description 获取基本信息
     * @param {*} row 项目对象
    */
    initBaseInfo(row) {
      let { projectName, totalGrossWeight, totalNetWeight, totalVolume, ladingBillCode,
        customsDeclarationNo, boxQuantity20, boxQuantity40, terminalPort,
        extractBoxPort, destinationPort, remark, totalQuantity, deliveryFactory,
        outboundOrderNo, outboundDate, outboundOrderNumber, totalPayablePrice,
        totalReceivablePrice, receivableBillHeadId, outboundBalanceDimension
       } = row
      let baseInfoObj = {
        projectName,
        outboundOrderNo,
        outboundDate,
        totalQuantity,
        totalGrossWeight,
        totalNetWeight,
        totalVolume,
        totalPayablePrice:totalPayablePrice?totalPayablePrice:'',
        totalReceivablePrice:totalReceivablePrice?totalReceivablePrice:'',
        ladingBillCode: ladingBillCode ? ladingBillCode: '--',
        customsDeclarationNo,
        boxQuantity20,
        boxQuantity40,
        terminalPort,
        extractBoxPort,
        destinationPort,
        outboundOrderNumber: outboundOrderNumber ? outboundOrderNumber: '--',
        deliveryFactory,
        remark
      }
      this.baseInfoObj = baseInfoObj
      this.receivableBillHeadId = receivableBillHeadId
      this.downExcelName = `${outboundBalanceDimension === 1?'提单号':'出仓编号'}${outboundBalanceDimension === 1?ladingBillCode:outboundOrderNumber}费用明细`
    },

    /**
     * @description 获取项目操作明细
     * @param {*} row 项目对象
     */
    initExitWarehouseOperateList(orderFeeList, addServiceFeeList) {
      if (addServiceFeeList.length) {
        let enterAddServiceFeeListArr = []
        let exitAddServiceFeeListArr = []
        addServiceFeeList.map(i => {
          let obj = {}
          obj.id = i.id
          obj.name = i.name
          obj.accountsType = i.accountsType
          if (i.orderId !== undefined) obj.orderId = i.orderId
          obj.keyword = i.keyword
          obj.lookUpId = i.billHeadId ? i.billHeadId : null
          obj.lookUpName = ''
          if (i.billHead) obj.lookUpName = i.billHead.name
          obj.status = i.isBalance ? 1 : 0
          obj.statusVal = i.isBalance ? '已结算' : '未结算'
          obj.agentBusiness = i.agentBusiness ? 1 : 0
          obj.currencySystem = i.currency
          obj.totalAmount = i.price
          obj.remark = i.remark
          i.accountsType === 1 ? enterAddServiceFeeListArr.push(obj) : exitAddServiceFeeListArr.push(obj)
        })
        this.tabsList[0].addServicetableData = enterAddServiceFeeListArr
        this.tabsList[1].addServicetableData = exitAddServiceFeeListArr
      }

      let enterOperatorListArr = []
      let exitOperatorListArr = []
      orderFeeList.map(i => {
        let obj = {}
        obj.id = i.id
        obj.sort = i.sort
        obj.orderId = i.orderId
        obj.feeName = i.feeName
        obj.keyword = i.keyword
        obj.feeUnit = i.feeUnit
        obj.feeBasic = i.feeBasic
        obj.calculateType = i.calculateType
        obj.currencySystem = i.currency
        obj.accountsType = i.accountsType
        obj.lookUpId = i.billHeadId ? i.billHeadId : null
        obj.lookUpName = ''
        if (i.billHead) obj.lookUpName = i.billHead.name
        obj.customsDeclarationNo = i.customsDeclarationNo
        obj.isCustomsDeclarationFeeType = i.isCustomsDeclarationFeeType
        obj.orderNo = i.orderNo
        obj.agentBusiness = i.agentBusiness ? 1 : 0
        obj.status = i.isBalance ? 1 : 0
        obj.statusVal = i.isBalance ? '已结算' : '未结算'
        obj.remark = i.remark
        obj.nums = 0
        obj.twentyNums = 0
        obj.fortyNums = 0
        if (i.calculateType === 2 || i.calculateType === 3) {
          if (i.calculateType === 3) obj.nums = i.feeJson.feeData
          if (i.calculateType === 2) {
            obj.twentyNums = i.feeJson.feeData20
            obj.fortyNums = i.feeJson.feeData40
          }
        }

        obj.currencySystemList = []
        let currencySystemPriceListObj = []
        i.feeRule.map((j, jIndex) => {
          let obj2 = {}
          obj2.id = j.currency
          obj2.name = this.currencySystemObj[j.currency]
          obj2.defaultCurrency = j.defaultCurrency
          if (i.calculateType === 2) {
            if (i.feeBasic === 1) {
              if (currencySystemPriceListObj.indexOf(j.currency) === -1) {
                obj2.feeBasicName = j.feeBasicName
                obj2.twentyUnitPriceReceivable = j.receivableUnitPrice
                obj2.twentyPayableUnitPrice = j.payableUnitPrice
                obj2.fortyUnitPriceReceivable = i.feeRule[jIndex + 1].receivableUnitPrice
                obj2.fortyPayableUnitPrice = i.feeRule[jIndex + 1].payableUnitPrice
                currencySystemPriceListObj.push(j.currency)
                obj.currencySystemList.push(obj2)
              }
            } else {
              obj2.unitPriceReceivable = j.receivableUnitPrice
              obj2.payableUnitPrice = j.payableUnitPrice
              obj.currencySystemList.push(obj2)
            }
          } else {
            obj2.unitPriceReceivable = j.receivableUnitPrice
            obj2.payableUnitPrice = j.payableUnitPrice
            obj.currencySystemList.push(obj2)
          }
        })

        let priceObj = obj.currencySystemList.find(item => { return item.id === i.currency })
        if (i.calculateType === 2 && i.feeBasic === 1) {
          obj.twentyPrice = i.accountsType === 1 ? priceObj.twentyUnitPriceReceivable : priceObj.twentyPayableUnitPrice,
            obj.fortyPrice = i.accountsType === 1 ? priceObj.fortyUnitPriceReceivable : priceObj.fortyPayableUnitPrice

          obj.totalAmount = i.accountsType === 1 ? i.feeJson.receivablePrice : i.feeJson.payablePrice
        } else {
          obj.price = i.accountsType === 1 ? priceObj.unitPriceReceivable : priceObj.payableUnitPrice
          obj.totalAmount = i.accountsType === 1 ? i.feeJson.receivablePrice : i.feeJson.payablePrice
        }

        i.accountsType === 1 ? enterOperatorListArr.push(obj) : exitOperatorListArr.push(obj)
      })

      this.tabsList[0].tableData = enterOperatorListArr
      this.tabsList[1].tableData = exitOperatorListArr
      this.onChangeName()
    },

    onSaveRemarks(v) {
      this.baseInfoObj.remark = v
      this.initDetails()
    },

    /* 添加服务 */
    onAddDomain(tabs) {
      // let headerObj = this.defaultAccountsReceivableHeaderList.find(item => {return item.id == this.receivableBillHeadId})
      // let lookUpName = headerObj.name
      
      let obj = {
        feeName: '',
        feeNameId: null,
        // lookUpName: tabs === "receivable" ? lookUpName :'',
        lookUpId: tabs === "receivable" ?this.receivableBillHeadId:'',
        currencySystem: 'CNY',
        agentBusiness: 0,
        totalAmount: 0,
        status: 0,
        statusVal: '未结算',
        accountsType: tabs === "receivable" ? 1 : 2
      }
      tabs === "receivable" ? this.tabsList[0].addServicetableData.push(obj) : this.tabsList[1].addServicetableData.push(obj)
      this.onChangeName()
    },

    onChangeName() {
      let receivableEmptyHeadUpSign = false
      let payEmptyHeadUpSign = false
      this.tabsList.map(i => {
        i.addServicetableData.map(j => {
          if (j.accountsType === 1) {
            if (!j.lookUpId) receivableEmptyHeadUpSign = true
          } else {
            if (!j.lookUpId) payEmptyHeadUpSign = true
          }
        })

        i.tableData.map(j => {
          if (j.accountsType === 1) {
            if (!j.lookUpId) receivableEmptyHeadUpSign = true
          } else {
            if (!j.lookUpId) payEmptyHeadUpSign = true
          }
        })
      })

      this.receivableEmptyHeadUpSign = receivableEmptyHeadUpSign
      this.payEmptyHeadUpSign = payEmptyHeadUpSign
    },
    
    
    /* 保存登记 */
    saveRegister(formName, type) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = this.orderId
          let orderFeeList = []
          let emptyCurrency = false
          let emptyHeadUp = false
          let receivableEmptyHeadUpSign = false
          let payEmptyHeadUpSign = false
          let addServiceFeeList = []
          this.tabsList.map(i => {
            if (type === i.key) {
              i.addServicetableData.map(j => {
                let obj = {}
                obj.id = j.id
                obj.name = j.name 
                obj.orderId = j.orderId
                obj.keyword = j.keyword
                obj.isBalance = j.status?true:false
                obj.billHeadId = j.lookUpId
                // obj.billHeadName = j.lookUpName
                obj.currency = j.currencySystem
                obj.agentBusiness = j.agentBusiness ? true : false
                obj.accountsType = j.accountsType
                obj.remark = j.remark
                obj.price = j.totalAmount
                if (!j.currencySystem) emptyCurrency = true
                if (!j.lookUpId) emptyHeadUp = true
                if (j.accountsType === 1) {
                  if (!j.lookUpId) receivableEmptyHeadUpSign = true
                } else {
                  if (!j.lookUpId) payEmptyHeadUpSign = true
                }
                addServiceFeeList.push(obj)
              })
  
              i.tableData.map(j => {
                let obj = {}
                obj.id = j.id
                obj.sort = j.sort
                obj.orderId = j.orderId
                obj.feeName = j.feeName
                obj.keyword = j.keyword
                obj.feeUnit = j.feeUnit
                obj.feeBasic = j.feeBasic
                obj.calculateType = j.calculateType
                obj.currency = j.currencySystem
                obj.accountsType = j.accountsType
                obj.remark = j.remark
                obj.billHeadId = j.lookUpId
                // obj.billHeadName = j.lookUpName
                obj.agentBusiness = j.agentBusiness ? true : false
                obj.isBalance = j.status?true:false
                obj.price = Number(j.totalAmount)
                obj.customsDeclarationNo = j.customsDeclarationNo
                obj.isCustomsDeclarationFeeType = j.isCustomsDeclarationFeeType
                obj.orderNo = j.orderNo
                if (!j.currencySystem) emptyCurrency = true
                if (!j.lookUpId) emptyHeadUp = true
                if (j.accountsType === 1) {
                  if (!j.lookUpId) receivableEmptyHeadUpSign = true
                } else {
                  if (!j.lookUpId) payEmptyHeadUpSign = true
                }
                obj.feeRule = []
                j.currencySystemList.map(v => {
                  if (j.calculateType === 2 && j.feeBasic === 1) {
                    let twentyObj = { 
                      currency: v.id, 
                      defaultCurrency: v.defaultCurrency, 
                      feeBasicName: '20尺柜', 
                      payableUnitPrice: v.twentyPayableUnitPrice, 
                      receivableUnitPrice: v.twentyUnitPriceReceivable 
                    }
                    let fortyObj = { 
                      currency: v.id, 
                      defaultCurrency: v.defaultCurrency, 
                      feeBasicName: '40尺柜', 
                      payableUnitPrice: v.fortyPayableUnitPrice, 
                      receivableUnitPrice: v.fortyUnitPriceReceivable 
                    }
  
                    obj.feeRule.push(twentyObj)
                    obj.feeRule.push(fortyObj)
                  } else {
                    let obj2 = {}
                    obj2.currency = v.id
                    obj2.defaultCurrency = v.defaultCurrency
                    obj2.payableUnitPrice = v.payableUnitPrice
                    obj2.receivableUnitPrice = v.unitPriceReceivable
                    obj.feeRule.push(obj2)
                  }
                })
                obj.feeJson = {}
                if (j.calculateType === 3) {
                  obj.feeJson.feeData = Number(j.nums)
                  if (j.accountsType === 1) {
                    obj.feeJson.receivablePrice = j.totalAmount
                    obj.feeJson.receivableUnitPrice = j.price
                  } else {
                    obj.feeJson.payablePrice = j.totalAmount
                    obj.feeJson.payableUnitPrice = j.price
                  }
                } else if (j.calculateType === 2) {
                  if (j.feeBasic === 1) {
                    obj.feeJson.feeBasicName20 = "20尺柜"
                    obj.feeJson.feeBasicName40 = "40尺柜"
                    obj.feeJson.feeData20 = j.twentyNums
                    obj.feeJson.feeData40 = j.fortyNums
                    j.currencySystemList.map(v => {
                      if (j.accountsType === 1) {
                        obj.feeJson.receivablePrice = Number(j.totalAmount)
                        obj.feeJson.receivablePrice20 = keepTwoDecimal(v.twentyUnitPriceReceivable * j.twentyNums)
                        obj.feeJson.receivablePrice40 = keepTwoDecimal(v.fortyUnitPriceReceivable * j.fortyNums)
                        obj.feeJson.receivableUnitPrice20 = v.twentyUnitPriceReceivable
                        obj.feeJson.receivableUnitPrice40 = v.fortyUnitPriceReceivable
                      } else {
                        obj.feeJson.payablePrice = Number(j.totalAmount)
                        obj.feeJson.payablePrice20 = keepTwoDecimal(v.twentyPayableUnitPrice * j.twentyNums)
                        obj.feeJson.payablePrice40 = keepTwoDecimal(v.fortyPayableUnitPrice * j.fortyNums)
                        obj.feeJson.payableUnitPrice20 = v.twentyPayableUnitPrice
                        obj.feeJson.payableUnitPrice40 = v.fortyPayableUnitPrice
                      }
                    })
                  } else {
                    j.currencySystemList.map(v => {
                      if (j.accountsType === 1) {
                        obj.feeJson.receivablePrice = Number(j.totalAmount)
                        obj.feeJson.receivableUnitPrice = v.unitPriceReceivable
                      } else {
                        obj.feeJson.payablePrice = Number(j.totalAmount)
                        obj.feeJson.payableUnitPrice = v.payableUnitPrice
                      }
                    })
                  }
                } else {
                  j.currencySystemList.map(v => {
                    if (j.accountsType === 1) {
                      obj.feeJson.receivablePrice = j.totalAmount
                      obj.feeJson.receivableUnitPrice = v.unitPriceReceivable
                    } else {
                      obj.feeJson.payablePrice = j.totalAmount
                      obj.feeJson.payableUnitPrice = v.payableUnitPrice
                    }
                  })
                }
                orderFeeList.push(obj)
              })
            }
          })
          this.receivableEmptyHeadUpSign = receivableEmptyHeadUpSign
          this.payEmptyHeadUpSign = payEmptyHeadUpSign
          if (emptyHeadUp) {
            return this.$message.error('抬头不能为空');
          }
          if (emptyCurrency) {
            return this.$message.error('币制不能为空');
          }

          let accountsType = type === 'receivable'?1:2
          let data = {
            id,
            accountsType,
            orderFeeList,
            addServiceFeeList
          }
          ExitWarehouseRegister.postSaveExitWarehouseRegister(id, data).then((res) => {
            if (res.success) {
              this.$message.success("登记成功");
              this.initDetails()
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    closeDialog() {
      this.$router.push({
        path: '/service/exit-warehouse-register-index/exit-warehouse-register-list',
      })
    },
    
    /** 
     * @desc 计算应收/付总金额
    */
    onTotalAmount() {
      let totalPayableAmount = 0
      let totalAmountReceivable = 0
      this.tabsList.map(i => {
        i.addServicetableData.map(j => {
          if (i.key === 'receivable') {
            totalAmountReceivable += Number(j.totalAmount)
          } else {
            totalPayableAmount += Number(j.totalAmount)
          }
        })
        i.tableData.map(j => {
          if (i.key === 'receivable') {
            totalAmountReceivable += Number(j.totalAmount)
          } else {
            totalPayableAmount += Number(j.totalAmount)
          }
        })
      })

      this.registeredFeetableData.map(i => {
        i.totalPayableAmount = keepTwoDecimal(totalPayableAmount)
        i.totalAmountReceivable = keepTwoDecimal(totalAmountReceivable)
        i.profit = keepTwoDecimal(totalAmountReceivable - (totalPayableAmount < 0?(-(totalPayableAmount)):totalPayableAmount))
      })
    },
    

    handDownExcelData(addServiceFeeList, orderFeeList) {
      // 应收
      let receivableList = []
      // 应付
      let payList = []

      if (addServiceFeeList.length) {
        addServiceFeeList.map(i => {
          let billHeadName = ''
          if (i.billHead) billHeadName = i.billHead.name
          let remark = ''
          if (i.remark !== null && i.remark !== undefined) remark = i.remark
          let arr = [0, i.name, i.agentBusiness?'是':'否', billHeadName, this.currencySystemObj[i.currency], i.price, i.isBalance?'已结算':'未结算', remark]
          if (i.accountsType === 1) {
            receivableList.push(arr)
          } else {
            payList.push(arr)
          }
        })
      }

      if (orderFeeList.length) {
        orderFeeList.map(i  => {
          let billHeadName = ''
          if (i.billHead) billHeadName = i.billHead.name
          let remark = ''
          if (i.remark !== null && i.remark !== undefined) remark = i.remark
          let arr = [0, i.feeName, i.agentBusiness?'是':'否', billHeadName, this.currencySystemObj[i.currency], i.price, i.isBalance?'已结算':'未结算', remark]
          if (i.accountsType === 1) {
            receivableList.push(arr)
          } else {
            payList.push(arr)
          }
        })
      }

      // 应收总价
      let downExcelReceivablePrice = 0
      // 应付总价
      let downExcelPayPrice = 0
      receivableList.map((i, index) => {
        i[0] = index+1
        downExcelReceivablePrice += Number(i[5])
      })
      receivableList.push(['','合计','','','',downExcelReceivablePrice,'',''])
      payList.map((i, index) => {
        i[0] = index+1
        downExcelPayPrice += Number(i[5])
      })
      payList.push(['','合计','','','',downExcelPayPrice,'',''])

      this.downExcelList = [
        {
          detailName: '应收',
          data: receivableList
        },
        {
          detailName: '应付',
          data: payList
        }
      ]
    },

    async downExcel() {
      const sheetsData = this.downExcelList.map((item) => {
        const sheetItem = {
          multiHeader: [[this.downExcelName]],
          merges: [`A1:H1`],
          sheetName: item.detailName,
          header: ["序号", "服务/费用名称", "代收代付", "抬头", "币制", "总价", "状态", "备注"],
          data: item.data
        }
        return sheetItem
      })
      const excel = await import('@/common/js/exportToExcel')
      excel.exportMultiSheetToExcel({
        sheetsData,
        filename: this.downExcelName
      })
    }
  }
}
</script>

<style lang='scss'>
.exit-warehouse-register-details {
  flex: 1;
  overflow-y: auto;
  padding-bottom: 40px;
  .enter-warehouse-register-form {
    .row {
      background: #fff;
      border-radius: 8px;
      margin-bottom: 20px;
      .code-name {
        padding: 0px 32px;
        .switch-tab {
          height: 52px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          overflow: auto;
          scrollbar-width: none;
          -ms-overflow-style: none;
          ::-webkit-scrollbar { display: none; }
          border-bottom: 1px solid #EEEEEE;
          &-item {
            height: 100%;
            line-height: 52px;
            cursor: pointer;
            font-size: 16px;
            color: #999999;
            margin-right: 10px;
            padding: 0px 12px;
          }
          &-item:last-child {
            margin-right: 0px;
          }
          &-active-item {
            color: #2E68EA;
            position: relative;
            &::after {
              content: '';
              position: absolute;
              left: 50%;
              bottom: 0px;
              transform: translate(-50%);
              height: 3px;
              width: 100%;
              background-color: #2E68EA;
            }
          }
        }
      }
      .sub-title {
        height: 52px;
        line-height: 52px;
        border-bottom: 1px solid #eee;
        padding-left: 32px;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
      }
      .row-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eee;
        padding-right: 32px;
        .sub-title {
          border-bottom: none;
        }
      }
      .entry-title {
        display: flex;
        justify-content: space-between;
        padding-right: 32px;
      
        .open-close {
          font-size: 14px;
          color: #2E68EA;
          cursor: pointer;
          font-family: "PingFang SC-Regular";
        }
      }
      
      .close-entry-title {
        border: none;
      }
      .base-info-title {
        margin-top: 25px;
      }
      // .enter-warehouse-operate {
      //   padding: 20px 32px;
      //   .enter-warehouse-operate-fee {
      //     display: grid;
      //     grid-template-columns: repeat(3, 1fr);
      //     column-gap: 93px;
      //     border-bottom: 1px dashed #D2D1D1;
      //     margin-bottom: 15px;
      //     .el-form-item {
      //       margin-bottom: 30px;
      //       .el-form-item__label {
      //         font-size: 14px;
      //         color: #666666;
      //         .settlement {
      //           width: 36px;
      //           height: 20px;
      //           margin-left: 10px;
      //         }
      //       }
      //       .el-form-item__content {
      //         .el-input.white .el-input__suffix {
      //           top: 0px;
      //           right: 10px;
      //         }
      //         .el-input--suffix .el-input__inner {
      //           padding-right: 50px;
      //         }
      //         .unit2 .el-input__inner {
      //           padding-right: 60px;
      //         }
      //         .unit3 .el-input__inner {
      //           padding-right: 76px;
      //         }
      //         .el-input.is-disabled {
      //           .el-input__inner {
      //             font-size: 14px;
      //             color: #333333;
      //             background-color: #F9F9F9;
      //             border: none;
      //           }
      //           .el-input__prefix, .el-input__suffix {
      //             color: #999;
      //           }
      //         }
      //       }
      //     }
      //     .cupboard {
      //       display: flex;
      //       flex-direction: column;
      //       .el-form-item__label {
      //         width: 100%;
      //         text-align: left;
      //       }
      //       .el-form-item__content {
      //         display: flex;
      //         .el-input {
      //           margin-right: 10px;
      //         }
      //         .el-input:last-of-type {
      //           margin-right: 0px;
      //         }
      //       }
      //     }
      //   }
        
      //   .add-service {
      //     border-bottom: 1px dashed #D2D1D1;
      //     margin-bottom: 20px;
      //     padding-bottom: 10px;
      //     .row-item {
      //       padding: 13px 0px 0px 0px;
      //       border-top: 1px solid #eee;
      //     }
      //     .increment-service {
      //       .increment-service-title-content {
      //         display: flex;
      //         .increment-service-title {
      //           margin-top: 9px;
      //           font-size: 14px;
      //           font-weight: 400;
      //           color: #666666;
      //           margin-right: 8px;
      //         }
      //         .el-button.btn-text {
      //           font-size: 12px;
      //         }
      //       }
      //       .row-item {
      //         border-top: none;
      //         position: relative;
      //         display: flex;
      //         justify-content: flex-start;
      //         align-items: center;
      //         &::before {
      //           content: '';
      //           position: absolute;
      //           width: 1px;
      //           height: 77px;
      //           background: #E0E8FC;
      //           top: -24px;
      //           left: 8px;
      //         }
      //       }
      //       .remove-domain {
      //         margin-top: 15px;
      //       }
      //       .el-form-item {
      //         display: flex;
      //         flex-direction: column;
      //         width: 160px;
      //         margin-right: 20px;
      //         .el-form-item__label {
      //           text-align: left;
      //           .settlement {
      //             width: 36px;
      //             height: 20px;
      //             margin-left: 4px;
      //           }
      //         }
      //         .el-form-item__content {
      //           display: flex;
      //           justify-content: flex-start;
      //           align-items: center;
      //           .el-input.white .el-input__suffix {
      //             top: 0px;
      //             right: 10px;
      //           }
      //           .el-select {
      //             width: 100%;
      //           }
      //           .el-input.is-disabled {
      //             .el-input__inner {
      //               font-size: 14px;
      //               color: #333333;
      //               background-color: #F9F9F9;
      //               border: none;
      //             }
      //             .el-input__prefix, .el-input__suffix {
      //               color: #999;
      //             }
      //           }
      //           .sort {
      //             flex-shrink: 0;
      //             display: inline-block;
      //             width: 16px;
      //             height: 16px;
      //             line-height: 16px;
      //             text-align: center;
      //             background: #2E68EA;
      //             border-radius: 2px;
      //             font-size: 14px;
      //             font-weight: 400;
      //             color: #FFFFFF;
      //             margin-right: 10px;
      //           }
      //         }
      //       }
      //       .service-name {
      //         width: 320px;
      //         margin-right: 66px;
      //         .el-form-item__label {
      //           padding-left: 26px;
      //         }
      //         .el-form-item__error {
      //           left: 26px;
      //         }
      //       }
      //     }
          
      //     .increment-service :nth-child(2){
      //       &::before {
      //         content: '';
      //         display: none;
      //       }
      //     }
      //   }
      // }
      
    }
    .footer {
      position: fixed;
      bottom: 46px;
      left: 216px;
      border-radius: 0px 0px 8px 8px;
      width: calc(100% - 247px);
      height: 64px;
      z-index: 9;
      overflow: hidden;
      background: white;
      margin-top: 13px;
      height: 66px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
